<template>
  <loader-wrapper :loading="loading">
    <div
      class="unknown-img"
      @mouseenter="handleEnter"
      @mouseleave="handleLeave"
    >
      <el-row
        :ref="file.id"
        type="flex"
        align="middle"
        :class="['img-actions', { 'd-none': !show }]"
      >
        <el-col v-if="['ttn', 'tn'].includes(type)" class="ta-l">
          <el-select
            v-model="variant"
            placeholder="Выберите сторону"
            size="small"
            class="variant-select"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in variants"
              :key="item.val"
              :label="item.label"
              :value="item.val"
            />
          </el-select>
        </el-col>
        <el-col class="ta-r">
          <i class="el-icon-zoom-in" @click="$emit('zoom', url)" />
          <i class="el-icon-refresh-left" @click="handleRotate(-90)" />
          <i class="el-icon-refresh-right" @click="handleRotate(90)" />
        </el-col>
      </el-row>
      <el-image :src="url" :scroll-container="container" lazy>
        <div slot="placeholder" class="mh-500">Загрузка...</div>
        <div slot="error" class="mh-500 redColor">Ошибка загрузки файла</div>
      </el-image>
    </div>
  </loader-wrapper>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { getVariants } from '@/views/UnknownFiles/constants'
import { mapMutations } from 'vuex'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const File = RepositoryFactory.get('file')

export default {
  name: 'ImgActions',
  components: { LoaderWrapper },
  props: {
    file: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    container: {
      type: [Object, HTMLDivElement],
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      version: 0,
    }
  },
  computed: {
    url() {
      return this.file.url + this.version
    },
    variants() {
      return getVariants(this.type)
    },
    variant: {
      get() {
        return this.file.variant
      },
      set(variant) {
        this.setVariant({ id: this.file.id, variant })
      },
    },
  },
  methods: {
    ...mapMutations('hardware', ['setVariant']),
    handleRotate(degrees) {
      this.loading = true
      File.rotate({ id: this.file.id, degrees })
        .then(() => (this.version += 1))
        .catch(err => this.errHandler(err))
        .finally(() => (this.loading = false))
    },
    handleEnter() {
      if (!this.show) {
        this.$refs[this.file.id]?.$el.classList.add('df-i')
      }
    },
    handleLeave() {
      if (!this.show) {
        this.$refs[this.file.id]?.$el.classList.remove('df-i')
      }
    },
  },
}
</script>

<style lang="sass">
.unknown-img
  position: relative
  display: block
  margin-bottom: 10px
  background: #F9F9F9
  text-align: center
  .el-image
    pointer-events: none
  .mh-500
    min-height: 500px
    padding-top: 30px
    font-size: 20px
  .img-actions
    position: absolute
    background: rgba(0, 0, 0, 0.7)
    width: 100%
    z-index: 1
    &.df-i
      display: flex !important
    .variant-select
      margin-left: 10px
      width: auto
    .ta-r i
      font-size: 40px
      color: #FFFFFF
      margin: 10px
      cursor: pointer
</style>
